module.exports = __webpack_public_path__ + "static/spinner-position-dont-f2074358bedf1f28b427eedf389cb2d6.png";